import {auth, firebase} from './firebase';

// Sign Up
export const doCreateUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign In FB
export const doSignInWithGoogle = () =>
  auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());

  export const doSignInWithFacebook = () =>
  auth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
// Sign out
export const doSignOut = () =>
  auth.signOut();


// forget password
export const sendPassword = (email) =>
  auth.sendPasswordResetEmail(email);

//add user informations
export const addUserInfo = () =>
  firebase.database().ref('users_profiles').child(auth.currentUser.uid)
    .update({
      email : auth.currentUser.email
  });


//add user informations
export const updateUserInfo = (name, phone) =>

  firebase.database().ref('users_profiles').child(auth.currentUser.uid)
    .update({
      name: name,
      phone : phone
  });


  //get user informations
export const getUserInfo = (uid) =>
  firebase.database().ref('users_profiles/'+uid).once('value')
  .then(user => user.val())
  .catch(error => ({
    errorCode: error.code,
    errorMessage: error.message
  }));


// WEBPACK FOOTER //
// ./src/authDB.js